import util from '@bmp-vue/core/api/util'

const controller = 'NaoRamificados'
export default Object.assign({}, util.GetCrud(controller, ['getall', 'get', 'put', 'delete']), {
    GetRelatorioNaoRamificadosPorData(dto){
        return util.Axios.GetAll(`${controller}/GetRelatorioNaoRamificadosPorData`, dto)
    }
})
